import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import { IconCart } from '../Icons';
import { StyledButton, StyledDiv } from './CartBtnStyles';

var _ref2 = React.createElement(IconCart, null);

var CartBtn = function CartBtn(_ref) {
  var handleCartOpen = _ref.handleCartOpen,
      cartQuantity = _ref.cartQuantity;

  return ReactDOM.createPortal(React.createElement(
    StyledButton,
    { 'aria-label': 'Open Cart', onClick: handleCartOpen },
    React.createElement(
      StyledDiv,
      null,
      _ref2,
      cartQuantity > 0 && React.createElement(
        'span',
        null,
        cartQuantity
      )
    )
  ), document.getElementById('dormify-header__cart'));
};

CartBtn.propTypes = {
  handleCartOpen: PropTypes.func.isRequired,
  cartQuantity: PropTypes.number
};

export default CartBtn;